import { z } from 'zod';
import { paginationQuerySchema } from '../common/envelope.js';
import { addressSchema } from '../common/address.js';
export const lifecycleStageSchema = z.enum(['prospect', 'customer', 'former_customer', 'partner']);
export const createCompanySchema = z.object({
    name: z.string().trim().min(1).max(200),
    domain: z.string().trim().max(200).optional(),
    industry: z.string().trim().max(150).optional(),
    sizeBand: z.string().trim().max(50).optional(),
    phone: z.string().trim().max(40).optional(),
    email: z.string().trim().email().max(200).optional(),
    description: z.string().trim().max(2000).optional(),
    website: z.string().trim().url().optional(),
    address: addressSchema.optional(),
    ownerId: z.string().uuid().optional(),
    lifecycleStage: lifecycleStageSchema.default('prospect'),
    customFields: z.record(z.string(), z.unknown()).default({}),
});
export const updateCompanySchema = createCompanySchema.partial().extend({
    version: z.number().int().nonnegative(),
});
export const listCompaniesQuerySchema = paginationQuerySchema.extend({
    ownerId: z.string().uuid().optional(),
    lifecycleStage: lifecycleStageSchema.optional(),
});
export const companyResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    domain: z.string().nullable(),
    industry: z.string().nullable(),
    sizeBand: z.string().nullable(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    description: z.string().nullable(),
    website: z.string().nullable(),
    address: addressSchema.nullable(),
    lifecycleStage: lifecycleStageSchema,
    customerSince: z.string().datetime().nullable(),
    owner: z.object({ id: z.string().uuid(), displayName: z.string() }).nullable(),
    tags: z.array(z.object({ id: z.string().uuid(), name: z.string(), color: z.string() })),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    version: z.number().int(),
});
/** design/orion-crm-design/rendered-html/CompanyDetail.html's 4-stat
 * header strip. */
export const companySummaryResponseSchema = z.object({
    openPipeline: z.object({ value: z.string(), dealCount: z.number().int(), topStageName: z.string().nullable() }),
    contactsCount: z.number().int(),
    activitiesLast90Days: z.number().int(),
    lastActivity: z.object({ occurredAt: z.string().datetime(), kind: z.string(), actorName: z.string().nullable() }).nullable(),
});
//# sourceMappingURL=schemas.js.map